import React from 'react';
import PropTypes from 'prop-types';

import FilterList from '../FilterList';
import CheckboxList from '../CheckboxList';

class HomeFilterOptions extends React.Component {
  componentDidMount() {
    const { filter, trackViewedMobileFilters, isSelectionPage } = this.props;

    // check to see if this is a individual filer page on the mobile web version.
    const filterId = isSelectionPage ? filter.id : null;

    trackViewedMobileFilters(filterId);
  }

  render() {
    const {
      id,
      filter,
      setSelectedFilters,
      hideHeader,
      selectedFilters,
      sidebarLayout,
    } = this.props;

    const isChecked = (option) => selectedFilters.includes(option.target_params.queryParams);

    const findSelectedId = (options) => {
      const selected = options.filter((opt) => isChecked(opt));
      return selected[0] && selected[0].id;
    };

    if (filter.optionsType === 'MULTI_CHOICE') {
      return (
        <CheckboxList
          id={id}
          data={filter.options}
          handleChange={(_, option) => {
            setSelectedFilters(option, filter);
          }}
          filterType={filter.id}
          isChecked={(option) => isChecked(option)}
          title={hideHeader ? null : filter.header}
          isLabelLeft={!sidebarLayout}
        />
      );
    }

    if (filter.optionsType === 'SINGLE_CHOICE') {
      return (
        <FilterList
          id={id}
          filters={filter.options}
          selected={findSelectedId(filter.options)}
          onSelect={(_, option) => {
            setSelectedFilters(option, filter);
          }}
          title={hideHeader ? null : filter.header}
          isLabelLeft={!sidebarLayout}
        />
      );
    }

    return null;
  }
}

HomeFilterOptions.defaultProps = {
  sidebarLayout: false,
  hideHeader: false,
  isSelectionPage: false,
  trackViewedMobileFilters: () => {},
};

HomeFilterOptions.propTypes = {
  id: PropTypes.string.isRequired,
  filter: PropTypes.shape({
    id: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    images: PropTypes.shape({
      icon: PropTypes.shape({
        image: PropTypes.string,
        name: PropTypes.string,
      }),
    }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.number,
        name: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    ).isRequired,
    styling: PropTypes.shape({
      mobile: PropTypes.shape({
        collapse: PropTypes.string,
        seperators: PropTypes.string,
      }),
      desktop: PropTypes.shape({
        collapse: PropTypes.string,
        seperators: PropTypes.string,
      }),
    }),
    optionsType: PropTypes.string.isRequired,
  }).isRequired,
  setSelectedFilters: PropTypes.func.isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  hideHeader: PropTypes.bool,
  sidebarLayout: PropTypes.bool,
  trackViewedMobileFilters: PropTypes.func,
  isSelectionPage: PropTypes.bool,
};

export default HomeFilterOptions;
